import React, { useEffect, useState } from 'react'
import Navbar from './navbar'
import { Link, useNavigate } from 'react-router-dom'
import UseSend from '../hooks/useSend'
import UseRegister from '../hooks/useRegister'

function Register() {
    const [username,setUsername] = useState()
    const [pass,setPass] = useState()
    const [pass1,setPass1] = useState()
    const [email,setEmail] = useState()
    const {sendData,result,token} = UseRegister();
    const navigate = useNavigate()

useEffect(()=>{
    if(result && result.token){
    navigate('/home');
    }
},[result,navigate])
    const loginHandler =(e)=>{
      e.preventDefault();
      if(username == ''){
        alert('username is required')
        return
      }
      if(pass == ''){
        alert('password is required')
        return
      }
      if(pass1 == ''){
        alert('confirm password is required')
        return
      }
        sendData(username,email,pass,pass1)
    }
  return (
    <>
    <Navbar/>
   <div style={{height:400,display:'flex',justifyContent:'center',alignItems:'center'}}>
      
      <form onSubmit={loginHandler} style={{display:'flex',flexDirection:'column',width:'30%'}}>
        <div style={{display:'flex',flexDirection:'column',margin:10}}>
          <label htmlFor='username'>Username</label>
        <input onChange={(e)=>setUsername(e.target.value)}  id="username" style={{height:25,borderRadius:5,outline:'none',borderWidth:1}}/>
        </div>
        <div style={{display:'flex',flexDirection:'column',margin:10}}>
          <label htmlFor='email'>Email</label>
        <input onChange={(e)=>setEmail(e.target.value)} id="email" style={{height:25,borderRadius:5,outline:'none',borderWidth:1}}/>
        </div>
        <div style={{display:'flex',flexDirection:'column',margin:10}}>
          <label htmlFor='password'>Password</label>
        <input onChange={(e)=> setPass(e.target.value)}  id="password" style={{height:25,borderRadius:5,outline:'none',borderWidth:1}}/>
        </div>
        <div style={{display:'flex',flexDirection:'column',margin:10}}>
          <label htmlFor='password2'>Confirm Password</label>
        <input onChange={(e)=> setPass1(e.target.value)} id="password2" style={{height:25,borderRadius:5,outline:'none',borderWidth:1}}/>
        </div>
        <div style={{display:'flex',flexDirection:'column',margin:10}}>
        <button type='submit' style={{backgroundColor:'blue',height:29,borderRadius:10,border:'none',color:'white'}}>Submit</button>
         <Link to={'/login'}>Already registerd, Login</Link>
        </div>
      </form>
    </div>
    </>
  )
}

export default Register
